<template>
<div>
    <b-form-group label-cols="2" horizontal label="예약 내용" class="mt-2">

        <b-form-group label-cols="3" label="예약번호" class="mb-1">
            <b-form-input class="modalFontSize" :plaintext="true" v-model="data.bookingNo" />
        </b-form-group>

        <b-form-group v-if="data.b2bChannelCode =='KAKAOB'" label-cols="3" label="외부채널 예약번호" class="mb-1">
          <b-form-input class="modalFontSize" :plaintext="true" v-model="data.b2bBookingNo" />
        </b-form-group>

        <b-form-group label-cols="3" label="예약자" class="mb-1">
            <b-form-input class="modalFontSize" :plaintext="!editFlag" v-model="data.visitorName" />
        </b-form-group>

        <b-form-group label-cols="3" label="전화번호" class="mb-1">
            <b-form-input class="modalFontSize" :plaintext="!editFlag" v-model="phoneNumber" />
        </b-form-group>
        <span v-if="cancelRes">
            <b-form-group label-cols="3" label="인원" class="mb-1">
                <b-row>
                    <p style="padding-left: 15px; margin: 0; margin-top: 6px; width: 100%;" class="modalFontSize">성인 : {{ data.adultHeadcount }}명 </p>
                    <!--          <b-form-input style="width:75%; padding: 0;" :plaintext="!editFlag" v-model="data.adultHeadcount" type="number" max="100" min="0"/>-->
                    <p style="padding-left: 15px; margin: 0; width: 100%;" class="modalFontSize">소인 : {{ data.childHeadcount }}명</p>
                    <!--          <b-form-input style="width:85%; padding: 0;" :plaintext="!editFlag" v-model="data.childHeadcount" type="number" max="100" min="1"/>-->
                    <p style="padding-left: 15px; margin: 0; width: 100%;" class="modalFontSize">유아 : {{ data.babyHeadcount }}명</p>
                    <!--          <b-form-input style="width:85%; padding: 0;" :plaintext="!editFlag" v-model="data.babyHeadcount" type="number" max="100" min="1"/>-->
                </b-row>
            </b-form-group>
            <b-form-group label-cols="3" label="요청사항" class="mb-1">
                <b-form-input class="modalFontSize" :plaintext="!editFlag" v-model="data.visitorRequests" />
            </b-form-group>

            <b-form-group label-cols="3" label="방문매장" class="mb-1">
                <b-form-input class="modalFontSize" :plaintext="true" v-model="data.storeName" />
            </b-form-group>

            <b-form-group label-cols="3" label="방문예정일" class="mb-1">
                <b-form-input class="modalFontSize" :plaintext="true" v-model="reservationDate" />
            </b-form-group>

            <b-form-group label-cols="3" label="예약신청일" class="mb-1">
                <b-form-input class="modalFontSize" :plaintext="true" v-model="bookingRequestDate" />
            </b-form-group>

            <b-form-group label-cols="3" label="예약상태" class="mb-1">
                <b-form-input class="modalFontSize" :plaintext="true" v-model="bookingStatusText" />
                <b-button variant="outline-success" @click="cancelReservation('book')" v-if="data.bookingStatus === 'Booked'">
                    예약취소
                </b-button>
                <b-button variant="outline-success" class="mr-1" @click="cancelReservation('noshow')" v-if="data.bookingStatus === 'Booked'">노쇼
                </b-button>
            </b-form-group>
        </span>
    </b-form-group>

    <b-form-group label-cols="2" horizontal label="구매 내역" class="mt-4">
        <b-table id="table-transition-example" :items="data.orderItems" :fields="fields" class="mb-0">
            <template v-slot:cell(goodsName)="row">
                <div>
                    <div>
                        {{ row.item.goodsName }}
                    </div>
                    <div style="color: #909090; text-decoration: underline" v-b-tooltip.hover="{ variant: 'info' }" :title="row.item.goodsTag" v-if='row.item.goodsTag != null && row.item.goodsTag !== ""'>
                        {{ goodsTagEllipse(row.item.goodsTag) }}
                    </div>
                </div>
            </template>
            <template v-slot:cell(depositBooking)="row">
                <div>
                    {{ row.item.depositAmount | numFormat }}

                </div>
            </template>
            <template v-slot:head(unused)="row" v-if="checkUse">
                <b-form-checkbox :checked="true" :unchecked-value="false" v-if="cancelRes" v-model="allCheck"></b-form-checkbox>
            </template>

            <template v-slot:cell(unused)="row" >
                <span v-if="row.item.itemStatus==='Consumed'">이용완료</span>
                <b-form-checkbox v-else-if="checkUse &&cancelRes" :checked='true' :unchecked-value='false'  v-model="row.item.unused" @change="depositAmountChk(row.item.itemNo,$event)"></b-form-checkbox>

            </template>

        </b-table>
        <div v-if="data.depositBooking == true && data.bookingStatus === 'Booked' || data.bookingStatus === 'BookingRequested' && cancelRes">
            <div class="timeSaleRateDiv">
                <div>
                    <span>시간대 할인율: {{ Number(data.timeSaleRate) + '%' }} </span>
                </div>
                <div v-if="cancelRes">
                    <span>선택된 예약금 합계</span> <span>{{ depositAmountSum | numFormat }}</span>
                </div>
            </div>
        </div>
        <div v-else-if="data.depositBooking == true && cancelRes && data.bookingStatus == 'Visited'">
            <div class="timeSaleRateDiv">
                <div>
                    <span>시간대 할인율: {{ Number(data.timeSaleRate) + '%' }} </span>
                </div>
                <div v-if="cancelRes">
                    <span>예약금 합계</span> <span>{{ data.depositAmountTotal | numFormat }}</span>
                </div>
            </div>
        </div>
        <!-- {{ data }} -->
        <div class="penaltyDiv mt-5" v-if="this.depositAmountArr.includes(false) && cancelRes && Number(data.cancellationFeeRate) !== 0">
            <span>
                사용하지 않는 쿠폰은 {{ Number(data.cancellationFeeRate) }}% 위약금이 부과됩니다
            </span>
            <b-form-checkbox :checked='true' :unchecked-value='false' v-model="noPenaltyVisit" @change="noPenaltyVisitEve">위약금 부과하지 않기</b-form-checkbox>
        </div>
    </b-form-group>
    <b-form-group v-if="!cancelRes">
        <!-- 예약취소 -->
        <div>
            <p class="cancelResRadiobox">
                <span class="mr-2">환불방법:</span>
                <span v-for="(item,idx) in avaArray" :key="idx" :value="item" @change="chkavaeve">{{item | avaKr}}</span>
            </p>
            <p>
                <span v-for="(item,idx) in avaArray" :key="idx">
                    {{ bprtext(item,Number(refundData.bookingPenaltyRate),booknoshow) }}
                </span>
            </p>
            <p>
                <span v-for="(item,idx) in avaArray" :key="idx">
                    {{ csText(item,booknoshow) }}
                </span>
            </p>
            <p>

            </p>
            <p>
                <span>취소사유</span>
                <b-input-group class="mt-3 mb-3">
                  <select class="form-control mr-3 col-4" v-model="type" >
                    <template v-for="item in typeList">
                      <option :key="item" :value="item.value" :hidden="!item.value" >
                        {{item.label}}
                      </option>
                    </template>
                  </select>
                  <select class="form-control mr-3 col-4" v-model="reasonType" >
                    <template v-for="item in reasonTypeList">
                      <option :value="item.value" :hidden="!item.value" >
                        {{item.label}}
                      </option>
                    </template>
                  </select>
                </b-input-group>
                <b-form-textarea rows="3" max-rows="3" v-model="cancelResmemo" no-resize></b-form-textarea>
            </p>
            <div v-if="noPenalty">해당 예약에 취소 위약금이 부과 되지 않습니다.</div>
            <b-form-checkbox v-if="Number(refundData.bookingPenaltyRate) !== 0" :checked='true' :unchecked-value='false' v-model="noPenalty">위약금 부과하지 않기</b-form-checkbox>
            <div class="text-center">
                <b-button variant="outline-success" @click="backRes">
                    취소
                </b-button>
                <b-button variant="outline-success" @click="cancelResApprove()">
                    승인
                </b-button>
            </div>
        </div>
    </b-form-group>
</div>
</template>

<script>
import {
    alignTableCenter,
    eventBus
} from "../../../utils";
import {
    _bookingStatus
} from "../../../constants/common";
import api from '../../../constants/api';
import {
    mapGetters
} from "vuex";

export default {
    name: 'BookingVisitDetail',
    components: {},
    props: ['data', 'modifyFlag', 'checkUseFlag'],
    data() {
        return {
            booknoshow: '',
            chkava: '',
            avaArray: [],
            refundData: {},
            cancelResmemo: "",
            depositAmountArr: [],
            depositAmountArris: false,
            noPenaltyVisit: true,
            noPenalty: false,
            cancelRes: true,
            depositAmountSum: 0,
            editFlag: this.modifyFlag !== undefined ? this.modifyFlag : false,
            checkUse: this.checkUseFlag !== undefined ? this.checkUseFlag : true,
            allCheck: false,
            orderItemsFields: [{
                    key: 'itemNo',
                    label: "쿠폰번호",
                    ...alignTableCenter
                },
                {
                    key: 'goodsName',
                    label: "상품명",
                    ...alignTableCenter
                },
                {
                    key: 'optionName',
                    label: "옵션명",
                    ...alignTableCenter
                },
            ],
          type :null,
          reasonType:null,
          typeList:[
            {
              label: "귀책자",
              value: null,

            },
            {
              label: "매장",
              value: "PARTNER"
            },{
              label: "구매자",
              value: "PURCHASER"
            },{
              label: "기타",
              value: "ETC"
            },
          ],
          reasonTypeList:[
            {
              label: "취소사유",
              value: null
            },
            {
              label: "구매자 요청",
              value: "PURCHASER_REQUEST"
            },
            {
              label: "재예약 진행",
              value: "RE_BOOKING"
            },
            {
              label: "건강상의 이유",
              value: "HEALTH_REASON"
            },{
              label: "타사 최저가 이용",
              value: "THIRD_PARTY_LOWEST_PRICE"
            },
            {
              label: "단순 변심",
              value: "SIMPLE_REMORSE"
            },
            {
              label: "장소 운휴",
              value: "STORE_SUSPENSION"
            },{
              label: "예약 마감",
              value: "BOOKING_CLOSED"
            },
            {
              label: "모객 부족",
              value: "SHORTAGE_OF_PURCHASERS"
            },
            {
              label: "천재지변",
              value: "NATURAL_DISASTER"
            },
            {
              label: "감염병 안전수칙 준수",
              value: "INFECTIOUS_DISEASE_SAFETY_RULES"
            },
          ],

        }
    },
    filters: {
        avaKr(val) {
            if (val === 'PaymentCancel') {
                return '결제취소';
            }
            if (val === 'CreateRefundCs') {
                return '계좌이체';
            }
            if (val === 'RestoreCoupon') {
                return '예약권 복원';
            }
        },
    },
    computed: {
        ...mapGetters(["currentUser", "siteName", "brandInfo"]),
        fields: {
            get: function () {
                return this.checkUse === false ? this.orderItemsFields : [...this.orderItemsFields, {
                    key: 'unused',
                    label: '',
                    ...alignTableCenter
                }]
            }
        },
        phoneNumber: {
            get: function () {
                return this.data.visitorPhone.replace(/^(\d{2,3})(\d{3,4})(\d{4})$/, `$1-$2-$3`)
            }
        },
        bookingStatusText: {
            get: function () {
                return _bookingStatus[this.data.bookingStatus]
            }
        },

        reservationDate: {
            get: function () {
                return this.$moment(this.data.reservationDate).format('YYYY-MM-DD HH:mm')
            }
        },
        bookingRequestDate: {
            get: function () {
                return this.$moment(this.data.bookingRequestDate).format('YYYY-MM-DD HH:mm')
            }
        },
        headcount: {
            get: function () {
                return {
                    adult: 0,
                    child: 0
                }
            }
        }
    },

    mounted() {

        this.allCheck = true;
        if (this.data.depositBooking == true) {
            // alert('false');
            this.orderItemsFields.push({
                key: 'depositBooking',
                label: "예약금",
                ...alignTableCenter
            })
        }

    },

    methods: {
        noPenaltyVisitEve() {
            this.$emit('noPenaltyVisitEve', this.noPenaltyVisit)
        },
        bprtext(val, penalty, noshow) {
            let noshowtext = '';
            if (noshow === 'noshow') {
                noshowtext = '노쇼'
            } else {
                noshowtext = '예약'
            }
            if (val === 'PaymentCancel') { // 결제취소
                if (Number(penalty) === 0) {
                    return;
                } else {
                    return `위약금 : 결제금액의 ${penalty}% 부과`;
                }
            }
            if (val === 'CreateRefundCs') { // 계좌이체
                if (Number(penalty) === 0) {
                    return;
                } else {
                    return `위약금 : 결제금액의 ${penalty}% 부과`;
                }
            }
            if (val === 'RestoreCoupon') { //쿠폰복원
                return `${noshowtext} 취소 시 예약된 쿠폰이 예약가능 상태로 복원되며,\n
                주문 상세 화면에서 신규 예약을 신청하거나 구매를 취소 할 수 있습니다.`;
            }
        },
        csText(val, noshow) {
            if (val === 'CreateRefundCs') { // 계좌이체
                return `환불cs 처리 후 계좌이체를 통해 환불 됩니다.`
            }
        },
        backRes() {
            this.$emit('cancelRespar', true);
            this.cancelRes = true;
            this.type=null
            this.reasonType=null
        },
        cancelResApprove() {
            let url = '';
            if (this.booknoshow === 'noshow') {
                url = api.order.noShowbrd;
            } else {
                url = api.order.brdcancelBooking;
            }
            //type, reasonType 두개 추가
            if(this.data.b2bChannelCode == 'KAKAOB'){
              if(!this.type || !this.reasonType){
                alert("취소사유를 선택해주세요!")
                return
              }
            }


            const reqUrl = api.changeAPI(this.siteName, api.basicURL + url)
            var params = {
                bookingNo: this.data.bookingNo,
                noPenalty: this.noPenalty,
                reasonType : this.reasonType,
                type : this.type,
                memo: this.cancelResmemo,
            }
            eventBus.$emit('bus-event', true);
            this.$http.post(reqUrl, params, {
                headers: {
                    'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
                }
            }).then(res => {
                if (res.data.code === "OK") {
                    eventBus.$emit('bus-event', false);
                    this.$emit('hideModal', '');
                    this.$emit('searchData', '');
                    this.type=null
                    this.reasonType=null
                } else {
                    throw 400
                }
            }).catch(err => {
                eventBus.$emit('bus-event', false);
                alert(err.response.data.message)
            })
        },
        chkavaeve(val) {
            this.chkava = val;
            console.log(val)
        },
        depositAmountChk(itemNo, val) {
            let vm = this;
            vm.depositAmountSum = 0;
            vm.depositAmountArr = [];
            let two = 2;
            this.data.orderItems.forEach(function (value) {
                if (itemNo === value.itemNo) {
                    value.unused = val
                }
                if(value.itemStatus !=="Consumed"){
                  if (value.unused === true) {
                    vm.depositAmountArr.push(true);
                    vm.depositAmountSum += Number(value.depositAmount);
                  } else {
                    vm.depositAmountArr.push(false);
                  }
                }

            })
             console.log(vm.depositAmountArr)
        },
        cancelReservation(type) {
            this.noPenalty = false;
            this.cancelRes = false;
            this.$emit('cancelRespar', this.cancelRes);
            let url = '';
            this.booknoshow = type;
            if (type === 'noshow') {
                url = api.order.noShowRefundAmount;
            } else {
                url = api.order.refundAmount
            }
            const reqUrl = api.changeAPI(this.siteName, api.basicURL + url)
            var params = {
                bookingNo: this.data.bookingNo,
                cancellationDate: null,
            }

            this.$http.post(reqUrl, params, {
                headers: {
                    'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
                }
            }).then(res => {
                if (res.data.code === "OK") {
                    this.refundData = res.data.data;
                    this.avaArray = [];
                    let refundDataArr = ['PaymentCancel', 'CreateRefundCs', 'RestoreCoupon'];
                    this.avaArray.push(this.refundData.preferredRefundMethod);
                    this.chkava = this.refundData.preferredRefundMethod;

                    console.log(this.refundData);
                } else {
                    throw 400
                }
            }).catch(err => {
                alert(err.response.data.message)
            })
        },
        goodsTagEllipse(goodsTag) {
            let length = 25;
            goodsTag = "(" + goodsTag + ")";

            if (goodsTag.length > length) {
                return goodsTag.substr(0, length - 2) + '...';
            } else {
                return goodsTag;
            }
        }
    },

    watch: {
        allCheck(chk) {
            let two = 2;
            let vm = this;
            vm.depositAmountSum = 0;
            vm.depositAmountArr = [];
            this.data.orderItems.forEach(function (value) {
              if(value.itemStatus !=='Consumed'){
                value.unused = chk;
                  if (chk === false) {
                    vm.depositAmountSum = 0;
                    vm.depositAmountArr.push(false)
                  } else {
                    vm.depositAmountArr.push(true)
                    vm.depositAmountSum += Number(value.depositAmount);
                  }
                }
            })

        }
    }
}
</script>
<style>
.modalFontSize {
  font-size: 0.9rem !important;
}

</style>
